import { Inject, Injectable, Injector } from '@angular/core';
import { AppContext, BackEndMessage, BindingList, DataPropInfo, EventBus, FrameComponent, FrameContext, NgFormControl, Translate, TranslateToken } from '@farris/devkit';
/**
 * åç«¯æ¶æ¯å¤çæå¡
 * @description
 * ### æå¡æ³¨å¥ä½ç½®
 *  1ãæ´ä¸ªè¡¨åçroot-component 
 *  2ãå¼¹åºçªå£çroot-component 
 */
@Injectable()
export class BackEndMessageHandler implements BackEndMessage.IBackEndMessageHandler {
  constructor(private injector: Injector, private frameContext: FrameContext, @Inject(TranslateToken) private translate: Translate) { }
  /**
   * å¤çåç«¯è¿åçæ¶æ¯æéè¯¯
   * @param message æ¶æ¯æéè¯¯
   */
  public handle(message: BackEndMessage.IMessage, context: any) {
    const isException = context && context.isException || false;
    const hasThrowError = context && context.hasThrowError || false;
    const eventBus = context && context.eventBus || null;
    const error = context && context.error || null;
    const formAppContext = context && context.formAppContext || null;
    const result = this.collect(message, isException, hasThrowError, eventBus, error, formAppContext);
    if (result && result.form && result.form.length > 0) {
      result.form.forEach((item: { frameContext: FrameContext, message: any }) => {
        item.frameContext.viewModel.form.updateFormErrors(item.message, true, 'backend');
      });
    } else {
      this.resetFormMessage(message.context.appContext, message.context.ns);
    }
    const targetFrameContext: FrameContext = this.findTargetFrameContext(this.frameContext);
    if (result && result.all && result.all.length > 0) {
      targetFrameContext.viewModel.verifycationChanged.next(result.all);
    } else {
      if (result !== null) {
        targetFrameContext.viewModel.verifycationChanged.next([]);
      }
    }
  }
  /**
   * æ¶éæ±æ»ä¿¡æ¯åformä¿¡æ¯
   * @param backEndMessage 
   */
  private collect(backEndMessage: BackEndMessage.IMessage, isException: boolean = false, hasThrowError: boolean = false, eventBus: EventBus = null, error: any = null, formAppContext: AppContext = null): { form: { frameContext: FrameContext, message: any }[], all: any[] } {
    const bizMessages = backEndMessage && backEndMessage.bizMessages || null;
    const appContext = backEndMessage && backEndMessage.context.appContext;
    const ns = backEndMessage.context.ns;
    if (!bizMessages || bizMessages.length < 1) {
      return null;
    }
    const result = {
      form: [],
      all: []
    };
    let hasFormlessError = false;
    for (let bizMessage of bizMessages) {
      const message = bizMessage.message;
      const location = bizMessage.location || null;
      const columns = location && location.columns || null;
      const nodeCode = location && location.nodeCode || null;
      const rows = location && location.rows;
      const bindingPath = this.getBindingPath(appContext, ns, nodeCode);
      const bindingPaths = bindingPath && bindingPath.split('/').filter(p => p);

      // ç®åä»å¤çælocationï¼ä¸æidãååãè¡¨åçã
      if (!location || !columns || columns.length < 1 || !nodeCode || !rows || rows.length < 1) {
        continue;
      }
      // éåæ°æ®è¡
      for (let row of rows) {
        for (let column of columns) {
          // è·åå°ææç»å®è¯¥åæ°æ®çframeContext
          let frameContexts = this.getFrameContextsByBindingPathAndColumnName(appContext, ns, bindingPath, column);
          if (!frameContexts || frameContexts.length < 1) {
            // æ²¡æä»»ä½ä¸ä¸ªç»ä»¶ç»å®è¯¥åçæ°æ®
            hasFormlessError = true;
            continue;
          }
          // æé¤æåªè¯»datagrid
          frameContexts = frameContexts.filter((frameContext: FrameContext) => {
            const isDataGridComponent = this.isDataGridComponent(frameContext.frameComponent);
            if (isDataGridComponent) {
              const isReadonlyDataGrid = this.isReadonlyDataGrid(frameContext.frameComponent);
              if (isReadonlyDataGrid) {
                return false;
              } else {
                return true;
              }
            }
            return true;
          });
          // éåçè¡æ¯å¦ä¸ºå½åè¡
          const isCurrentRow = this.isCurrentRow(appContext, ns, bindingPath, row);
          // å¦ææ¯å½åè¡çè¯éè¦å°éè¯¯ä¿¡æ¯æ¾å°formä¸­
          if (isCurrentRow) {
            // å¿½ç¥grid
            // const formFrameContexts = frameContexts.filter(frameContext => !this.isGridComponent(frameContext.frameComponent));
            if (frameContexts && frameContexts.length > 0) {
              frameContexts.forEach((frameContext: FrameContext) => {
                // åªå¤çäºä¸ä¸ªç»ä»¶ä¸­ååªç»å®å°ä¸ä¸ªåç«¯æ§ä»¶çåºæ¯
                const formControls = this.getFormControlByColumnName(frameContext, column);
                if (formControls && formControls.length > 0) {
                  formControls.forEach(([domPropertyName, formControl]) => {
                    //const domPropertyName = formControl && formControl. || null;
                    this.mergeMessage(result.form, frameContext, domPropertyName, message);
                  });
                }

                //if (formControl && domPropertyName) {

                //}
              });
            } else {
            }
          }
          // å°éè¯¯ä¿¡æ¯æ¾å°æ±æ»ä¸­
          frameContexts.forEach((frameContext: FrameContext) => {
            const viewModelName = frameContext.viewModel.form.formGroupName;
            const formControls = this.getFormControlByColumnName(frameContext, column);
            if (formControls && formControls.length > 0) {
              const [domPropertyName, formControl] = formControls.find(([propertyName, formControl]) => propertyName && propertyName.length > 0);
              // const domPropertyName = domProperty && domProperty.propertyName;
              const bindingList = frameContext.viewModel.bindingData.getValue(bindingPaths) as BindingList;
              let index = bindingList.getIndexById(row);
              const primary = `${row}_${column}_${message}`;
              // TODO:è½ç¶è½çº æ­£æ±æ»æ¶æ¯æ¾ç¤ºéå¤çé®é¢ï¼ä½å¯è½å¯¼è´ç¹å»éè¯¯æ æ³å®ä½å°å¯¹åºæ§ä»¶çé®é¢ï¼å¾åç»­ä¼å
              if (index >= 0 && result.all.findIndex(p => p.id === primary) === -1) {
                // æ°æ®æºä¸­æå¤äº1è¡æ¶æ¾ç¤ºç´¢å¼
                const position = (bindingList && bindingList.length > 1) ? (index + 1) : -1;
                const title = this.buildItemTitle(viewModelName, formControl.name || formControl.defaultI18nValue || domPropertyName, position);
                const item = {
                  id: primary,
                  index,
                  targetField: formControl.id,
                  title,
                  msg: message,
                  namespace: ns,
                  bindingPath,
                  type: 'error'
                };
                result.all.push(item);
              }
            }

          });
        }
      }
    }
    if (hasFormlessError && isException && !hasThrowError && eventBus) {
      eventBus.post('Exception', '', 'onException', error, formAppContext);
    }
    return result;
  }
  private mergeMessage(formItems: { frameContext: FrameContext, message: { [domPropertyName: string]: { errors: { [messageType: string]: { name: string } } } } }[], frameContext: FrameContext, domPropertyName: string, message: string) {
    const targetItem = formItems.find(item => item.frameContext.frameId === frameContext.frameId);
    if (targetItem) {
      const isPropertyExist = targetItem.message && Object.keys(targetItem.message).includes(domPropertyName);
      const messageType = `backend-message-${Object.keys(targetItem.message).length + 1}`;
      if (isPropertyExist) {
        targetItem.message[domPropertyName]['errors'][messageType] = { name: message };
      } else {
        targetItem.message[domPropertyName] = { errors: { [messageType]: { name: message } } };
      }
    } else {
      formItems.push({
        frameContext: frameContext,
        message: {
          [domPropertyName]: {
            errors: {
              'backend-message-1': { name: message }
            }
          }
        }
      });
    }
  }
  private buildItemTitle(viewModelName: string, propertyName: string, index: any) {
    const template = {
      'zh-CHS': {
        viewModelName: `$viewModel`,
        index: `ç¬¬ $index è¡`,
        propertyName: `- $propertyName`
      },
      'en': {
        viewModelName: `$viewModel`,
        index: `row $index`,
        propertyName: `- $propertyName`
      },
      'zh-CHT': {
        viewModelName: `$viewModel`,
        index: `ç¬¬ $index è¡`,
        propertyName: `- $propertyName`
      }
    };
    const currentLanguage = this.translate.getCurrentLanguage() || 'zh-CHS';
    const message = [];
    if (viewModelName) {
      message.push(template[currentLanguage]['viewModelName'].replace('$viewModel', viewModelName));
    }
    if (index > 0) {
      message.push(template[currentLanguage]['index'].replace('$index', index));
    }
    if (propertyName) {
      message.push(template[currentLanguage]['propertyName'].replace('$propertyName', propertyName));
    }
    return message.join(' ');
  }
  /**
   * æ ¹æ®è¡¨åænodeCodeè·åç»å®è·¯å¾
   * @param appContext appContext
   * @param ns ns
   * @param nodeCode è¡¨å
   */
  private getBindingPath(appContext: AppContext, ns: string, nodeCode: string) {
    const frameContext = this.getFrameContext(appContext, ns);
    return frameContext.repository.entityTypeInfo.getBindingPathByTableName(nodeCode);
  }
  /**
   * éè¿ç»å®è·¯å¾åååæ¾å°ææç¬¦åæ¡ä»¶çè§å¾æ¨¡å(åæ¬gridåform)
   * @param appContext appContext
   * @param ns namespace
   * @param bindingPath ç»å®è·¯å¾
   * @param columnName åå
   */
  private getFrameContextsByBindingPathAndColumnName(appContext: AppContext, ns: string, bindingPath: string, columnName: string): FrameContext[] {
    let frameContexts = appContext.frameContextManager.getFrameContexts();
    if (frameContexts && frameContexts.length > 0) {
      // æ¾å°formä¸­ææ§ä»¶çframeContext
      frameContexts = frameContexts.filter((frameContext: FrameContext) => {
        // åºæ¬æ¡ä»¶æ¯å¦æ»¡è¶³
        let isValidFrameContext = frameContext.namespace === ns && frameContext.viewModel.bindingPath === bindingPath && frameContext.viewModel.form && frameContext.viewModel.form.controls && Object.keys(frameContext.viewModel.form.controls).length > 0;
        if (!isValidFrameContext) {
          return false;
        }
        // åéè¿ååè¿æ»¤
        const bindingPaths = bindingPath.split('/').filter(p => p);
        const dataTypeInfo = frameContext.repository.entityTypeInfo.getTypeInfoByPath(bindingPaths);
        if (dataTypeInfo) {
          const dataPropInfos = Array.from(dataTypeInfo.propInfoMap.values());
          // ä»å½åå®ä½å±æ§ä¸­æ¾å°æ°æ®å­æ®µä¸ºååçå±æ§
          const entityPropertyInfo = dataPropInfos.find((propInfo: DataPropInfo) => propInfo.metadataInfo && (propInfo.metadataInfo.originalDataField === columnName || propInfo.metadataInfo.dataField === columnName));
          if (entityPropertyInfo) {
            const entityPropertyName = entityPropertyInfo.name;
            const ngFormControl = Object.values(frameContext.viewModel.form.ngFormControls).find(item => item.binding === entityPropertyName);
            if (ngFormControl) {
              return true;
            } else {
              const item = Object.keys(frameContext.viewModel.form.ngFormControls).find(key => key === entityPropertyName);
              return item ? true : false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
      return frameContexts;
    }
    return null;
  }
  /**
   * æ¯å¦ä¸ºdatagridç»ä»¶
   * @param frameComponent component
   */
  private isDataGridComponent(frameComponent: FrameComponent) {
    const columnNames = frameComponent.context.viewModel['dataGridColumnsName'] || null;
    return columnNames ? true : false;
  }
  /**
   * gridç»ä»¶æ¯å¦æ¯åªè¯»ç
   * @param frameComponent frameComponent
   * @returns 
   */
  private isReadonlyDataGrid(frameComponent: FrameComponent) {
    const frameContext = frameComponent.context;
    const dataGridColumnsName = frameContext.viewModel['dataGridColumnsName'] || null;
    if (dataGridColumnsName) {
      const datagridColumns: any[] = frameContext.viewModel[dataGridColumnsName];
      return datagridColumns.every((group: Array<any>) => {
        return group.every(item => !item.editor);
      });
    } else {
      throw new Error(`ä¼ å¥çç»ä»¶ä¸æ¯ä¸ä¸ªè¡¨æ ¼ï¼`);
    }
  }
  /**
   * idæ¯å¦ä¸ºå½åè¡
   * @param appContext appContext
   * @param ns namespace
   * @param bindingPath bindingPath
   * @param id id
   */
  private isCurrentRow(appContext: AppContext, ns: string, bindingPath: string, id: string) {
    const bindingPaths = bindingPath.split('/').filter(p => p);
    const frameContext = this.getFrameContext(appContext, ns);
    const bindingData = frameContext.bindingData;
    const bindingList = bindingData.getValue(bindingPaths) as BindingList;
    return bindingList.currentItem.primaryKeyValue === id;
  }
  /**
   * è·åå½ånsä¸çrootFrameContext
   * @param appContext appcontext
   * @param ns namespace
   */
  private getFrameContext(appContext: AppContext, ns: string) {
    const frameContexts = appContext.frameContextManager.getFrameContexts();
    if (frameContexts && frameContexts.length > 0) {
      const randomFrameContext = frameContexts.find(frameContext => frameContext.namespace === ns);
      if (randomFrameContext) {
        const virtualRootFrameContext = randomFrameContext.getVirtualRootFrameContext();
        return virtualRootFrameContext;
      }
    }
    return null;
  }
  /**
   * éè¿ç»å®è·¯å¾åååè·åç»å®å°è¯¥åçformControl
   */
  private getFormControlByColumnName(frameContext: FrameContext, columnName: string): Array<[string, NgFormControl]> {
    const bindingPaths = frameContext.viewModel.bindingPath.split('/').filter(p => p);
    // éè¿bindingPathæ¾å°å¯¹åºçå®ä½ä¿¡æ¯
    const typeInfo = frameContext.repository.entityTypeInfo.getTypeInfoByPath(bindingPaths);

    const propsInfo = Array.from(typeInfo.propInfoMap.values());
    const propInfo = propsInfo.find((propInfo: DataPropInfo) => propInfo.metadataInfo && (propInfo.metadataInfo.originalDataField === columnName || propInfo.metadataInfo.dataField === columnName));
    if (propInfo) {
      const mappingName = propInfo.name;
      const formControls: Array<[string, NgFormControl]> = Object.entries(frameContext.viewModel.form.ngFormControls).filter((item) => item[1].binding === mappingName || item[0] === mappingName);
      // const ngFormControl = Object.values(frameContext.viewModel.form.ngFormControls).find(item => item.binding === mappingName);
      if (formControls) {
        return formControls;
      }
    }
    return null;
  }
  private resetFormMessage(appContext: AppContext, ns: string) {
    const frameContexts = appContext.frameContextManager.getFrameContexts().filter(frameContext => frameContext.namespace === ns);
    frameContexts.forEach(frameContext => frameContext && frameContext.viewModel && frameContext.viewModel.form && frameContext.viewModel.form.clearBackendError());
  }
  /**
   * éå½æ¾å°å±ç¤ºæ¶æ¯çç»ä»¶ä¸ä¸æ
   * @param frameContext frameContext
   */
  private findTargetFrameContext(frameContext: FrameContext): FrameContext {
    const virtualRootFrameContext = frameContext.getVirtualRootFrameContext();
    const virtualRootComponent = virtualRootFrameContext.frameComponent;
    const isDialogComponent = virtualRootComponent && virtualRootComponent['isDialogRootComponent'] || false;
    if (isDialogComponent) {
      // å¦ææ¶æ¯å¤çæå¡æ¯å¼¹çªåçï¼åæ¶æ¯æç¤ºå±ç¤ºå¨å¼¹çªå
      return virtualRootFrameContext;
    } else {
      // å½åæ¶æ¯æå¡ä¸å¨å¼¹çªåï¼éå½åä¸æ¥æ¾ï¼æ¾å°ç¬¬ä¸ä¸ªå¼¹çªï¼å¦ææ¾ä¸å°åæ¾å°æä¸çroot-component
      const parentFrameContext = virtualRootFrameContext.parent;
      if (parentFrameContext) {
        return this.findTargetFrameContext(parentFrameContext);
      } else {
        return virtualRootFrameContext;
      }
    }
  }
}